import React from 'react'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import get from 'lodash/get'

import Avatar from '../components/Avatar'
import BlogHeader from '../styled/BlogHeader'
import Box from '../styled/Box'
import FlexGrid from '../styled/FlexGrid'
import Tags from '../components/Tags'
import TextLabel from '../styled/TextLabel'

function BlogMeta(props = {}) {
  const hasTags =
    get(props, 'frontmatter.tags') && get(props, 'frontmatter.tags').length > 0
  return (
    <FlexGrid gutter="l">
      <FlexGrid.Item mb={{ _: 'base', md: '0' }}>
        <FlexGrid alignItems="center">
          <FlexGrid.Item display={{ _: 'none', md: 'block' }}>
            <Avatar height="40px" width="40px" />
          </FlexGrid.Item>
          <FlexGrid.Item>
            <BlogHeader.TextLabel as={TextLabel}>Author</BlogHeader.TextLabel>
            <Box as="p" fontSize="xs">
              <Box as={Link} to="/">
                Drew Barontini
              </Box>
            </Box>
          </FlexGrid.Item>
        </FlexGrid>
      </FlexGrid.Item>
      <FlexGrid.Item mb={{ _: 'base', md: '0' }}>
        <BlogHeader.TextLabel as={TextLabel}>Published</BlogHeader.TextLabel>
        <Box as="p" fontSize="xs">
          {props.frontmatter.date}
        </Box>
      </FlexGrid.Item>
      <FlexGrid.Item mb={{ _: 'base', md: '0' }}>
        <BlogHeader.TextLabel as={TextLabel}>Reading Time</BlogHeader.TextLabel>
        <Box as="p" fontSize="xs">
          {props.timeToRead} min.
        </Box>
      </FlexGrid.Item>
      {hasTags && (
        <FlexGrid.Item mb={{ _: 'base', md: '0' }}>
          <BlogHeader.TextLabel as={TextLabel}>Tagged</BlogHeader.TextLabel>
          <Tags tags={props.frontmatter.tags} />
        </FlexGrid.Item>
      )}
    </FlexGrid>
  )
}

BlogMeta.propTypes = {
  frontmatter: PropTypes.object,
}

export default BlogMeta
